import { render } from "./TestResults.vue?vue&type=template&id=7391b662&scoped=true"
import script from "./TestResults.vue?vue&type=script&lang=js"
export * from "./TestResults.vue?vue&type=script&lang=js"

import "./TestResults.vue?vue&type=style&index=0&id=7391b662&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7391b662"]])

export default __exports__